export function getCurrentDateTime(newDate) {
    const separator = '-';
    const date = newDate.getDate();
    const month = newDate.getMonth() + 1;
    const year = newDate.getFullYear();
    const time = newDate.getHours() + ':' + newDate.getMinutes() + ':' + newDate.getSeconds();
    return `${date}${separator}${month < 10 ? `0${month}` : `${month}`}${separator}${year} ${time}`;
}

export function getCurrentDate(newDate) {
    const separator = '';
    const date = newDate.getDate();
    const month = newDate.getMonth() + 1;
    const year = newDate.getFullYear();

    return `${date}${separator}${month < 10 ? `0${month}` : `${month}`}${separator}${year}`;
}

export function getCurrentDatetimeStamp(newDate) {
    const date = newDate.getDate();
    const month = newDate.getMonth() + 1;
    const year = newDate.getFullYear();
    const timestamp = `${newDate.getHours()}` + `${newDate.getMinutes()}` + `${newDate.getSeconds()}`;
    return `${date}${month}${year}${timestamp}`;
}

export function getCurrentTimeStamp(newDate) {
    const timestamp = `${newDate.getHours()}` + `${newDate.getMinutes()}` + `${newDate.getSeconds()}`;
    return `${timestamp}`;
}

export function getCurrentDdTimeStamp(newDate) {
    const date = newDate.getDate();
    const month = newDate.getMonth() + 1;
    const minutes = newDate.getMinutes();
    const seconds = newDate.getSeconds();
    const timestamp = `${minutes < 10 ? `0${minutes}` : `${minutes}`}${seconds < 10 ? `0${seconds}` : `${seconds}`}`;
    return `${date}${month < 10 ? `0${month}` : `${month}`}${timestamp}`;
}
